import actionTypes from '../constants/action-types';
import constants from '../../../../common/constants';

const infoModalState = {
  show: false,
  type: '',
  message: '',
  translations: null,
  callback: null,
  path: null,
  btnText: null,
};

export const infoModalReducer = (state = infoModalState, payload) => {
  switch (payload.type) {
    case actionTypes.TOGGLE_INFO_MODAL:
      return {
        ...state,
        show: payload.data.show,
        type: payload.data.type,
        message: payload.data.message,
        translations: payload.data.translations,
        callback: payload.data.callback,
        path: payload.data.path,
        btnText: payload.data.btnText,
      };
    case actionTypes.TOGGLE_DEFAULT_ERROR_MODAL:
      return {
        ...state,
        show: true,
        type: constants.info_modal_types.error.value,
        message: 'COMMON.DEFAULT_ERROR_MESSAGE',
        translations: null,
        callback: null,
        path: null,
        btnText: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/info-modal/reducers/info-modal-reducers.js